import LoginForm from 'features/login/LoginForm';

const LoginPage = () => {
	return (
		<div>
			<LoginForm />
		</div>
	);
};

export default LoginPage;
